import { Inject, Injectable } from "@angular/core";
import { LinkSituation } from "@nms-ng2/app/modules/topology/links/links.model";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { LinkInfoCircuit } from "../links-step.model";

/**
 * Formata o LinkInfoCircuit para adicionar informações de exibição.
 */
@Injectable({
    providedIn: "root"
})
export class LinkFormatterService {

    constructor(@Inject(ANGULARJS_TRANSLATE) private readonly translate: any) { }

    formatLinks(links: Array<LinkInfoCircuit>): void {
        links.forEach((link) => this.formatLink(link));
    }

    private formatLink(link: LinkInfoCircuit): void {
        link.situation = this.formatSituation(LinkSituation[link.situation]);
        link.attenuation = this.formatAttenuation(link.attenuation);
        link.distance = this.formatDistance(link.distance);
    }

    private formatDistance(distance: string): string {
        return `${distance} km`;
    }

    private formatAttenuation(attenuation: string) {
        return `${attenuation} dB/km`;
    }

    private formatSituation(linkSituation: LinkSituation) {
        let situation = "";
        switch (linkSituation) {
            case LinkSituation.ACTIVE:
                situation = "link.situation.active";
                break;
            case LinkSituation.NOT_ACTIVE:
                situation = "link.situation.notActive";
                break;
        }

        return this.translate.instant(situation);
    }
}
